import type { Header } from '@tanstack/react-table';
import * as React from 'react';

import BaseHeaderCell from './BaseHeaderCell';
import HeaderGridCell from './HeaderGridCell';
import { getSimpleHeaderColumnRange } from './headerUtil';

interface OwnProps<T> {
	header: Header<T, unknown>;
	leafCount: number;
	leafIdIndex: Map<string, number>;
	onColumnDrag: (header: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
	setHeaderReference: (headerId: string) => (_ref: HTMLDivElement) => void;
}

type Props<T> = OwnProps<T>;

function SimpleHeaderRowItem<T>(props: Props<T>) {
	const {
		header,
		leafCount,
		leafIdIndex,
		onColumnDrag,
		setHeaderReference,
	} = props;

	const range = React.useMemo(() => getSimpleHeaderColumnRange(header, leafIdIndex), [header, leafIdIndex]);

	if (!range) {
		return null;
	}

	const { columnStart, columnEnd } = range;
	const isLastCol = columnEnd === leafCount;

	return (
		<HeaderGridCell
			colSpan={header.colSpan}
			columnStart={columnStart}
			isFirstCol={columnStart === 1}
			isLastCol={isLastCol}
			isLeaf={true}
			key={header.id}
			needsRightBorder={false}
			needsTopBorder={false}
		>
			{header.isPlaceholder ? null : (
				<BaseHeaderCell<T>
					header={header}
					isLeafHeader={true}
					onColumnDrag={onColumnDrag}
					setHeaderReference={setHeaderReference}
				/>
			)}
		</HeaderGridCell>
	);
}

export default React.memo(SimpleHeaderRowItem) as typeof SimpleHeaderRowItem;
